<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-select v-model="query.complete" filterable collapse-tags clearable placeholder="订单属性" class="handle-select mr10">
                        <el-option v-for="(row,index) in orderTypeList" :key="index" :label="row.title" :value="row.id"></el-option>
                    </el-select>
                    <el-select v-model="query.company_id" filterable multiple collapse-tags clearable placeholder="选择公司" class="handle-select mr10">
                        <el-option v-for="(row,index) in companyList" :key="index" :label="row.title" :value="row.id"></el-option>
                    </el-select>
                    <el-select v-model="query.cooperation_mode" filterable multiple collapse-tags clearable placeholder="合作模式" class="handle-select mr10">
                        <el-option v-for="(row,index) in cooperationModeList" :key="index" :label="row.title" :value="row.id"></el-option>
                    </el-select>
                    <el-select v-model="query.date_type" placeholder="时间类型" class="handle-select mr10">
                        <el-option key="event_date" label="举办日期" value="event_date"></el-option>
                        <el-option key="sign_date" label="签单日期" value="sign_date"></el-option>
                        <el-option key="create_time" label="创建日期" value="create_time"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.range" type="daterange" align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
                </div>
            </div>
        </div>
        <el-table id="out-table" :data="tableData" :height="height" border class="table" ref="multipleTable" header-cell-class-name="table-header" :default-sort="{prop:'event_date'}" :show-summary="true" :summary-method="getSummaries" v-loading="loading">
            <el-table-column type="index" width="60" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="complete" label="订单属性" align="center" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contract_no" label="合同编号" align="center" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="company" label="所属公司" align="left" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cooperation_mode" label="合作模式" align="center" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="event_date" label="举办日期" width="120" align="center" sortable show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.event_date}}</template>
            </el-table-column>
            <el-table-column prop="sign_date" label="签单日期" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="hotel" label="酒店" width="230" show-overflow-tooltip></el-table-column>
            <el-table-column prop="newer" label="新人姓名" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cmobile" label="客资手机号" align="center" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="news_type" label="订单类型" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="settle_real_total" label="返佣金额" width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totals" label="合同总额" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="banquet_suborder_totals" label="实收婚宴增项" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="earnest_money" label="实收定金" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="middle_money" label="实收中款" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tail_money" label="实收尾款" width="100" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="wedding_suborder_totals" label="实收婚庆增项" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cost_totals" label="消费总金额" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="protocol_totals" label="酒店协议总计" width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="paid_totals" label="实付总计" width="100" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="user" label="签单销售" width="100" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="department" label="所属区域" width="100" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
</template>

<script>
import './common.css';
import fileSaver from 'file-saver';
import xlsx from 'xlsx';

export default {
    name: 'basetable',
    data() {
        let height = window.innerHeight - 188;

        return {
            loading: false,
            sumFields: [
                'totals',
                'banquet_suborder_totals',
                'earnest_money',
                'middle_money',
                'tail_money',
                'wedding_suborder_totals',
                'cost_totals',
                'protocol_totals',
                'paid_totals'
            ],
            orderTypeList: [{
                id: '',
                title: '所有订单',
            },
            {
                id: 0,
                title: '普通订单',
            },
            {
                id: 98,
                title: '定金订单',
            },
            {
                id: 99,
                title: '意向金订单',
            },
            {
                id: 101,
                title: '退单',
            },
            ],
            height: height,
            departmentTree: [],
            tableData: [],
            query: {
                complete: '',
                department_id: '',
                company_id: '',
                cooperation_mode: '',
                date_type: '',
                keyword: '',
                range: []
            },
            cooperationModeList: [],
            companyList: [],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }
                ]
            }
        };
    },
    created() {

        this.getData();

        // 获取picker
        this.getPicker();
    },
    methods: {
        getData() {
            let that = this;
            let url = '/api/statistics.fiance/held';
            let query = that.query;
            that.loading = true;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.tableData = result.list;
                that.loading = false;
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.getData();
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取Picker
        getPicker() {
            let url = '/api/statistics.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.companyList = response.data.companyList;
                that.cooperationModeList = response.data.cooperationModeList;
            });
        },
        handleCascader(e) {
            let last = e.length - 1;
            this.query.department_id = e[last];
        },
        exportExcel() {
            /* 从表生成工作簿对象 */
            var wb = xlsx.utils.table_to_book(document.querySelector('#out-table'));
            /* 获取二进制字符串作为输出 */
            var wbout = xlsx.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            });
            try {
                fileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], {
                        type: 'application/octet-stream'
                    }),
                    //设置导出文件名称
                    'sheetjs.xlsx'
                );
            } catch (e) {
            }
            return wbout;
        },
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总价';
                    return;
                }

                if (this.sumFields.indexOf(column.property) < 0) {
                    sums[index] = '';
                    return;
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    let sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);

                    sums[index] = sum.toFixed(2);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        }
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');
</style>
